import {
  IonButtons,
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonList,
  IonSearchbar,
  IonToolbar,
} from '@ionic/react';
import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

import useLoading from '@hooks/useLoading';

const Toolbar = styled(IonToolbar)`
  && {
    padding-top: 0px;
  }
`;

interface Props {
  loadData: () => Promise<any>;
  onSearch: (value: string) => void;
  endOfList: boolean;
  buttons?: ReactNode;
  onClear?: () => void;
  isLoading?: boolean;
  children: ReactNode;
  title?: ReactNode;
  searchType?: 'text' | 'email';
}

const List = ({
  loadData,
  onSearch,
  endOfList,
  buttons,
  onClear,
  isLoading,
  children,
  title,
  searchType = 'text',
}: Props) => {
  const [searchText, setSearchText] = useState('');
  useLoading(isLoading);
  const onKeyUp = (key: string) => {
    if (key === 'Enter') {
      onSearch(searchText);
    }
  };

  const onIonInfinite = async (e: any) => {
    await loadData();
    e.target?.complete();
  };

  return (
    <IonContent>
      <IonHeader collapse="fade">
        <Toolbar>
          {title}
          <IonSearchbar
            value={searchText}
            aria-label="search"
            // skipcq: JS-0417
            onIonInput={(e: CustomEvent) => setSearchText(e.detail.value)}
            // skipcq: JS-0417
            onKeyUp={e => onKeyUp(e.key)}
            // skipcq: JS-0417
            onIonCancel={() => onSearch('')}
            // skipcq: JS-0417
            onIonClear={() => {
              onSearch('');
              onClear?.();
            }}
            showCancelButton="focus"
            type={searchType}
          />
          {buttons && <IonButtons slot="end">{buttons}</IonButtons>}
        </Toolbar>
      </IonHeader>
      <IonList>{children}</IonList>

      <IonInfiniteScroll
        // skipcq: JS-0417
        onIonInfinite={onIonInfinite}
        threshold="100px"
        disabled={endOfList}
      >
        <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText={t`Loading more data...`} />
      </IonInfiniteScroll>
    </IonContent>
  );
};

export default List;
